import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {notExistsInArrayValidator} from '../validatorFunctions';

@Directive({
  selector: '[gtNotExistInArrayValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: NotExistsInArrayValidatorDirective, multi: true}]
})
export class NotExistsInArrayValidatorDirective<T> implements Validator {
  @Input('gtNotExistInArrayValidator') array: Array<T>;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('errorMessage') errorMessage: string;

  validate(control: AbstractControl): {[key: string]: any} | null {
    if (this.errorMessage) {
      return notExistsInArrayValidator(this.array, this.errorMessage)(control);
    }
    return notExistsInArrayValidator(this.array)(control);
  }
}
